import React, { useEffect } from "react";
import Body from "../Body";
import Header from "../Header";
export const GlobalContainer = ({
  theme,
  children,
  animated,
  bgColor,
  withPadding = false,
}) => {
  useEffect(() => {
    document.body.style.backgroundColor = bgColor ? bgColor : "white";
  }, []);

  return (
    <div>
      <Header theme={theme} />
      <Body
        theme={theme}
        animated={animated}
        bgColor={bgColor}
        paddingTop={withPadding ? 80 : null}
      >
        {children}
      </Body>
    </div>
  );
};

export const OrderContainer = ({ children }) => {
  return <div>{children}</div>;
};

export const LoginContainer = ({ children }) => {
  return <div>{children}</div>;
};
